var _path, _path2, _circle, _circle2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTransactionRedeem(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 7H5.83333L7.50607 14.4388C7.71132 15.3515 8.52184 16 9.45735 16H16.6305C17.4441 16 18.1766 15.5071 18.4832 14.7535L21 8.56522",
    stroke: "#FC8E09",
    strokeWidth: 2,
    strokeMiterlimit: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3492 6.75926C16.7685 7.11868 17.3998 7.07012 17.7593 6.65079C18.1187 6.23147 18.0701 5.60017 17.6508 5.24074L16.3492 6.75926ZM13.5 3L14.1508 2.24074C13.7763 1.91975 13.2237 1.91975 12.8492 2.24074L13.5 3ZM9.34921 5.24074C8.92988 5.60017 8.88132 6.23147 9.24074 6.65079C9.60017 7.07012 10.2315 7.11868 10.6508 6.75926L9.34921 5.24074ZM12.5 10C12.5 10.5523 12.9477 11 13.5 11C14.0523 11 14.5 10.5523 14.5 10L12.5 10ZM17.6508 5.24074L14.1508 2.24074L12.8492 3.75926L16.3492 6.75926L17.6508 5.24074ZM12.8492 2.24074L9.34921 5.24074L10.6508 6.75926L14.1508 3.75926L12.8492 2.24074ZM12.5 3L12.5 10L14.5 10L14.5 3L12.5 3Z",
    fill: "#FC8E09"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 20,
    r: 2,
    fill: "#FC8E09"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 20,
    r: 2,
    fill: "#FC8E09"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransactionRedeem);
export default __webpack_public_path__ + "static/media/transaction-redeem.14903360bbe313e91d49c112cff340cb.svg";
export { ForwardRef as ReactComponent };